(() => {
  const SECTION_SELECTOR = '[data-stats-counter-section]';
  const VALUE_SELECTOR = '.js-stats-counter-value';

  function padValue(value, digitCount) {
    const sign = value < 0 ? '-' : '';
    const absoluteValue = Math.abs(value);
    return `${sign}${String(absoluteValue).padStart(digitCount, '0')}`;
  }

  function animateCounter(el) {
    if (!el || el.dataset.animated === 'true') return;

    const target = Number.parseInt(el.dataset.target || '0', 10);
    const safeTarget = Number.isFinite(target) ? target : 0;
    const digitCount = Math.max(Number.parseInt(el.dataset.digitCount || '1', 10), 1);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = padValue(safeTarget, digitCount);
      el.dataset.animated = 'true';
      return;
    }

    const startTime = performance.now();
    const duration = 1200;

    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(safeTarget * eased);

      el.textContent = padValue(current, digitCount);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      } else {
        el.textContent = padValue(safeTarget, digitCount);
        el.dataset.animated = 'true';
      }
    };

    window.requestAnimationFrame(tick);
  }

  function setInitialCounterValue(el) {
    if (!el || el.dataset.initialized === 'true') return;

    const digitCount = Math.max(Number.parseInt(el.dataset.digitCount || '1', 10), 1);
    const zeroValue = padValue(0, digitCount);

    el.textContent = zeroValue;
    el.dataset.initialized = 'true';
    el.dataset.animated = 'false';
  }

  function initSection(sectionRoot) {
    if (!sectionRoot) return;

    const counters = Array.from(sectionRoot.querySelectorAll(VALUE_SELECTOR));
    if (!counters.length) return;

    counters.forEach(setInitialCounterValue);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.35,
      }
    );

    counters.forEach((counter) => observer.observe(counter));
  }

  function initAll(root = document) {
    const sections = Array.from(root.querySelectorAll(SECTION_SELECTOR));
    sections.forEach(initSection);
  }

  window.addEventListener('DOMContentLoaded', () => initAll(document));

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:reorder', () => initAll(document));
  }
})();
